import { ListImage, Paragraph, Typography } from '../../designComponents';
import PDFPlaceholder from '../../designComponents/PDFPlaceholder';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { UploadedLogosContainerStyled } from '../TechnicianBrowsedJobDetails/style';
import { BlueprintDetailsStyled } from './style';

type Props = {
  blueprintOfProperty: string;
  floorTitle: { name: string; URL: string; id: string }[];
  note: string;
};

const BlueprintInformation = ({
  blueprintOfProperty,
  floorTitle,
  note,
}: Props) => {
  return (
    <BlueprintDetailsStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        BLUEPRINT INFORMATION
      </Typography>
      <VerticalSpaceStyled $space={30}>
        <InfoRowStyled className="blueprintInfo">
          <Typography fontColor="dark" className="key">
            Blueprint of Property :
          </Typography>
          <Typography className="value">{blueprintOfProperty}</Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          {floorTitle.map((Props, index) => {
            const url = new URL(Props.URL);

            const extension = url.pathname.split('.').pop();

            return (
              <div key={index} style={{ marginBottom: '15px' }}>
                <InfoRowStyled className="blueprintInfo">
                  <Typography fontColor="dark" className="key">
                    Floor Title :
                  </Typography>
                  <Typography variant="normal" className="value">
                    {Props.name}
                  </Typography>
                </InfoRowStyled>
                <UploadedLogosContainerStyled>
                  {extension !== 'pdf' ? (
                    <ListImage
                      imagesURL={[{ URL: Props.URL, id: Props.id }]}
                      imageHeight="143px"
                      imageWidth="192px"
                    />
                  ) : (
                    <PDFPlaceholder
                      link={Props.URL}
                      style={{ height: '143px', width: '192px' }}
                    />
                  )}
                </UploadedLogosContainerStyled>
              </div>
            );
          })}
        </InfoRowStyled>
        <InfoRowStyled $direction="column" style={{ margin: '30px 0px 0px' }}>
          <Typography fontColor="dark">Notes :</Typography>
          <Paragraph numberOfLines={5}>{note}</Paragraph>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BlueprintDetailsStyled>
  );
};

export default BlueprintInformation;
